module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-2": "",
      "pa-5": ""
    }
  }, [_c('V-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-30"
  }, [_vm._v("Proof of Enquiries & Trades")]), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("We Are Transforming The Future of Financial Markets")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": ""
    }
  }, [_c('v-container', {
    attrs: {
      "pa-0": "",
      "grid-list-xl": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        See\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                           The unseen\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        Trading charts only display the orders that were filled. What’s happening to the majority of the orders that were placed and canceled, the orders that ARE moving the market? Now you see them.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        True\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                           Market Intelligence\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        The prices flickering on your computer screen do not tell you the whole story of what is happening in the market. Far from it. It is just a very small tip of the iceberg. It often is what you do not see that will hurt you.\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_vm._v("\n                                        If your analysis is only based on the small available final prints of the filled trades, you have been missing 90% of the whole story of the market. Let’s look below the tip of the iceberg!\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Why bother\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        with the canceled orders?\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        The majority of the orders were never filled or never intended to be filled. But they are the ones that truly move the market and the prices that are disclosed to the public.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Promoting\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                           An Industry-wide Fair Trading Practice\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                       Through the IOB PoET smart contracts, every order that occurred on the network is recorded automatically on the distributed public ledger, regardless whether it is filled or not.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Preventing\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        Price Spoofing\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        Spoofing is a disruptive algorithmic trading entity employed by traders to outpace other market participants and to manipulate financial markets.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Proof of All Enquiries\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        PoET Addresses The Spoofing Problem\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        Recording all orders sent, not only the small fraction of executed orders. Every time an order is sent, it records its wallet address, time (accurate to a nanosecond), quantity, price, instrument, account/wallet ID, exchange(s) it was sent to.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Preventing\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        Front Running\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                       Front-running is the prohibited practice of entering into an order to capitalize on an advance, nonpublic knowledge of a large pending transaction that will influence the price of the underlying security. This is considered a form of market manipulation in many markets.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Proof of All Trades\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        Every Trade on An Immutable Distributed Public Ledger\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                       PoET records all transactions occurred on the network on an immutable public ledger. Every time an order is executed, it records its wallet address, time (accurate to a nanosecond), quantity, price, instrument, account/wallet ID, and exchange(s).\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Protocol\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        A market transparency protocol\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                       The market is often manipulated by the unfilled orders.\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_vm._v("\n                                       As regulation in the traditional financial markets is tightening the control of various market manipulations, IOB proposes a DLT solution to record every price and order enquiry ever sent – whether filled or not – and every trade ever executed on an immutable distributed public ledger, the IOB Proof of Enquiries & Trades (PoET) protocol.\n                                    ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": "",
      "mt-5": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "mx-3 mb-0 mt-2"
  }, [_vm._v("\n                                        IOB LLC offers market fraud detection products and services (IOB Analytics), coupled with automated trading systems through its structured market data (PoET), a social investment platform (SiP), and trader-generated data integration.Separate products are provided to address the needs of both professional traders (TCS) and Millennial/Gen Z traders (ioBots).\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-right mt-0"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.goUserRequest
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-lg-right",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": "",
      "mt-5": ""
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": _vm.domainName
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "20"
    }
  }, [_vm._v("arrow_back")])], 1)])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d9e829c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/Poet.vue
// module id = 437
// module chunks = 0